import { isDatabaseCorruption } from "@-/dev.improve.haniverse.lib.database.engine";
import { getDeviceAccount } from "@-/dev.improve.haniverse.lib.device-settings";
import { logger } from "@-/dev.improve.haniverse.lib.logger";
import { resetActorDatabaseForRecovery } from "#actor-database";
import { isActorSyncProvisioned } from "#resolve-actor-sync-url";

/**
 * A signed-in replica whose open failed because the file is damaged (quarantined by the engine's
 * integrity check, or refused as corrupt) is discarded so the next open bootstraps from the cloud
 * copy: the rebuild of section 7 in `database.md` with nothing to export, because a damaged file
 * cannot be read for its change log (the limit stated there). A signed-out database has no cloud
 * copy to return to, so it is left for the user's own decision in Settings.
 *
 * Returns whether the files were discarded, so the caller can open again.
 */
export async function discardCorruptActorReplica(error: unknown): Promise<boolean> {
  if (!isDatabaseCorruption(error) || !isActorSyncProvisioned(getDeviceAccount())) {
    return false;
  }
  await resetActorDatabaseForRecovery();
  logger(import.meta.location).warn("actor-db:corrupt-replica-discarded", error);
  return true;
}
